<template>
  <div class="ui stackable grid">
    <div class="flex-center">
      <h1>404 Not Found</h1>
      <p>I don't know what you're looking for but it's not here.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  data () {
    return {
    }
  },
  mounted () {
  }
}
</script>

<style scoped>
 .flex-center {
   max-width: 300px;
   margin: 30px auto 0;
 }
</style>